import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const QuickActionButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  const getContextualActions = () => {
    const path = location?.pathname;
    
    switch (path) {
      case '/branding-cost-calculator':
        return [
          { 
            label: 'Add Item', 
            icon: 'Plus', 
            action: () => console.log('Add new branding item'),
            color: 'bg-primary hover:bg-primary/90'
          },
          { 
            label: 'Quick Quote', 
            icon: 'Calculator', 
            action: () => console.log('Generate quick quote'),
            color: 'bg-accent hover:bg-accent/90'
          }
        ];
      
      case '/installation-tracking':
        return [
          { 
            label: 'Upload Photo', 
            icon: 'Camera', 
            action: () => console.log('Upload installation photo'),
            color: 'bg-primary hover:bg-primary/90'
          },
          { 
            label: 'Update Status', 
            icon: 'CheckCircle', 
            action: () => console.log('Update installation status'),
            color: 'bg-success hover:bg-success/90'
          }
        ];
      
      case '/store-layout-manager':
        return [
          { 
            label: 'New Layout', 
            icon: 'Layout', 
            action: () => console.log('Create new layout'),
            color: 'bg-primary hover:bg-primary/90'
          },
          { 
            label: 'Upload Plan', 
            icon: 'Upload', 
            action: () => console.log('Upload layout plan'),
            color: 'bg-secondary hover:bg-secondary/90'
          }
        ];
      
      case '/dashboard-overview':
        return [
          { 
            label: 'Quick Entry', 
            icon: 'Plus', 
            action: () => console.log('Quick data entry'),
            color: 'bg-primary hover:bg-primary/90'
          }
        ];
      
      default:
        return [
          { 
            label: 'Quick Action', 
            icon: 'Zap', 
            action: () => console.log('Default quick action'),
            color: 'bg-primary hover:bg-primary/90'
          }
        ];
    }
  };

  const actions = getContextualActions();
  const primaryAction = actions?.[0];

  const handlePrimaryAction = () => {
    if (actions?.length === 1) {
      primaryAction?.action();
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  const handleActionClick = (action) => {
    action?.action();
    setIsExpanded(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 lg:hidden">
      {/* Expanded Actions */}
      {isExpanded && actions?.length > 1 && (
        <div className="absolute bottom-16 right-0 flex flex-col gap-3 animate-slide-down">
          {actions?.slice(1)?.reverse()?.map((action, index) => (
            <Button
              key={index}
              onClick={() => handleActionClick(action)}
              className={`w-12 h-12 rounded-full shadow-elevated ${action?.color} text-white flex items-center justify-center transition-all duration-200 hover:scale-105`}
            >
              <Icon name={action?.icon} size={20} />
            </Button>
          ))}
        </div>
      )}
      {/* Primary Action Button */}
      <Button
        onClick={handlePrimaryAction}
        className={`w-14 h-14 rounded-full shadow-elevated ${primaryAction?.color} text-white flex items-center justify-center transition-all duration-200 hover:scale-105 ${
          isExpanded ? 'rotate-45' : ''
        }`}
      >
        <Icon 
          name={isExpanded && actions?.length > 1 ? 'Plus' : primaryAction?.icon} 
          size={24} 
        />
      </Button>
      {/* Action Label */}
      {!isExpanded && (
        <div className="absolute bottom-16 right-0 bg-gray-900 text-white text-xs px-2 py-1 rounded whitespace-nowrap opacity-0 hover:opacity-100 transition-opacity duration-200 pointer-events-none">
          {primaryAction?.label}
        </div>
      )}
      {/* Backdrop */}
      {isExpanded && (
        <div 
          className="fixed inset-0 bg-black/20 -z-10"
          onClick={() => setIsExpanded(false)}
        />
      )}
    </div>
  );
};

export default QuickActionButton;